import { providers } from "shared/config/consts/providers";
import { ZkCertType } from "shared/config/consts/zk-cert-types";

import { ProviderCard } from "./provider-card";

type Props = {
  type: ZkCertType;
  onSelect: (provider: string) => void;
};

const getTitle = (type: ZkCertType) => {
  if (type === "gip3") return "Select a Data provider";
  return "Select a KYC provider";
};

export const SelectProvider = (props: Props) => {
  const { onSelect, type } = props;

  const filteredProviders = providers.filter(
    (provider) => provider.type === type
  );

  return (
    <>
      <h2 className="mt-5 text-center text-2xl font-semibold whitespace-pre-line">
        {getTitle(type)}
      </h2>

      <div className="mt-5 flex w-full grow flex-col gap-3">
        {!filteredProviders.length && type === "gip1" && (
          <p className="text-balticSea/50 flex text-center">
            There are no providers supporting your country at the moment
          </p>
        )}
        {filteredProviders.map((provider) => {
          if (provider.type !== type) return;
          return (
            <ProviderCard
              key={provider.title}
              {...provider}
              onClick={() => {
                onSelect(provider.title);
              }}
            />
          );
        })}
      </div>
    </>
  );
};
